import React, { children } from 'react'
import HeaderNew from './HeaderNew';

// import Header1 from './Header1';
// import Headers from './Headers';





function Layout({children}) {
  return (
    <>
    <HeaderNew/>
    {/* <Header/> */}
   {/* <Header1/> */}
   {/* <Headers/> */}
   {/* <MainHeader/> */}
   {/* <Loginglobalheader/> */}
   <main>
        {children}   
      </main>
    {/* <Footer/> */}
   
    </>
  )
}

export default Layout;
